import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for zone shape types.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.ZONE_SHAPE_TYPES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const ZoneShapeTypeService = {
  FindMany
}

export default ZoneShapeTypeService
